// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-actions-__id-indexstyleGrid-container-olgdj{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-actions-__id-indexstyleGrid-grid-gjdzt{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-actions-__id-indexstyleGrid-col6-btubh{grid-column:span 6}.pages-actions-__id-indexstyleGrid-col3-buabb{grid-column:span 3}.pages-actions-__id-indexstyleGrid-col4-mulme{grid-column:span 4}.pages-actions-__id-indexstyleGrid-col9-btqty{grid-column:span 9}.pages-actions-__id-indexstyleGrid-col12-qhypw{grid-column:span 12}.pages-actions-__id-indexstyleGrid-alignItemsStart-bgwee{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-actions-__id-indexstyleGrid-container-olgdj",
	"grid": "pages-actions-__id-indexstyleGrid-grid-gjdzt",
	"col6": "pages-actions-__id-indexstyleGrid-col6-btubh",
	"col3": "pages-actions-__id-indexstyleGrid-col3-buabb",
	"col4": "pages-actions-__id-indexstyleGrid-col4-mulme",
	"col9": "pages-actions-__id-indexstyleGrid-col9-btqty",
	"col12": "pages-actions-__id-indexstyleGrid-col12-qhypw",
	"alignItemsStart": "pages-actions-__id-indexstyleGrid-alignItemsStart-bgwee"
};
module.exports = ___CSS_LOADER_EXPORT___;
